import stickySidebar from 'sticky-sidebar'

const init = () => {
    $('.body-blog__card').length ? 
    getSticky() : 
    0

    function getSticky(){
        // const sidebar = new stickySidebar('.body-blog__card')
        const sidebar = new stickySidebar('.body-blog__card');
    }
}

export default {
    init
}